'use client';

import React from 'react';

import { Tooltip as ArkTooltip } from '@shaojiang/components/ui/tooltip';

export type TooltipPlacement =
  'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';

interface Props {
  title: React.ReactNode;
  placement?: TooltipPlacement;
  children: React.ReactElement;
  /** Keep the tooltip open while the content is hovered */
  interactive?: boolean;
}

/**
 * Small wrapper around the Park UI tooltip with the `title` / `placement` API the site used with MUI.
 * The child must be a single element that can hold a ref (it becomes the trigger).
 */
export default function Tooltip({
  title,
  placement = 'top',
  children,
  interactive = false,
}: Props) {
  if (title === '' || title === null || title === undefined || title === false) {
    return children;
  }

  return (
    <ArkTooltip.Root
      openDelay={150}
      closeDelay={100}
      interactive={interactive}
      positioning={{ placement }}
    >
      <ArkTooltip.Trigger asChild>{children}</ArkTooltip.Trigger>
      <ArkTooltip.Positioner>
        <ArkTooltip.Arrow>
          <ArkTooltip.ArrowTip />
        </ArkTooltip.Arrow>
        <ArkTooltip.Content>{title}</ArkTooltip.Content>
      </ArkTooltip.Positioner>
    </ArkTooltip.Root>
  );
}
